import _isEqual from "lodash/isEqual";
import _reduce from "lodash/reduce";
import _get from "lodash/get";
import _isNumber from "lodash/isNumber";

import { getMetaInformation as getAdminMetaInfo } from "redux/reducers/admin";
import { getMetaInformation as getDealerMetaInfo } from "redux/reducers/dealer";
import { getMetaInformation as getManagementMetaInfo } from "redux/reducers/management";

import { isAdmin, isDealer, isManager } from "components/ui/authorized/AuthorizedRole";
import { openAlert } from "components/ui/customAlert";

/**
 * Make a random id
 * @param {Number} length The length of the id
 */
export const generateId = (length = 15) => {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < length; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};


export const mobilePhoneRe = /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([0-9]{3}( |-)?[0-9]{4})$/;

export const isMobilePhone = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

export const getExtension = (filename) => {
  const parts = filename.split('.');
  return parts[parts.length - 1];
}

export const isVideo = (filename) => {
  const ext = getExtension(filename.split('?')[0]);

  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
      return true;
  }
  return false;
}
/**
 * Convert a base64 string in a Blob according to the data and contentType.
 *
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
export const b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

/**
 * function to compare tow objects, useful to use at ShouldComponentUpdate
 * @param {Object} a Reference Object
 * @param {Object} b Compare Object
 */
export const diff = (a, b) => {
  return _reduce(
    a,
    function(result, value, key) {
      return _isEqual(value, b[key]) ? result : result.concat(key);
    },
    []
  );
}

export const isEqual = _isEqual;

export const getSuperintendentUserLabel = user => {
  if (!user) return '';

  const userFields = [
    user.first_name,
    user.last_name,
    `(${isManager(user.role_name) ? user.client_name : user.unit_name})`,
    `(${user.building_address})`,
    `[${user.username}]`
  ];

  return userFields.map(u => u && u.trim()).join(" ")
}

const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.mvisystem.mviandroid&hl=en_US"
const IOS_APP_URL = "https://apps.apple.com/us/app/m%C3%BF-mvi/id1659615163"

export const redirectToApp = ({ callback, source, token }={}) => {
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isIOS = /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)

  if (isAndroid || isIOS) {
    openAlert({
      onApply: () => {
        setTimeout(function () { window.location.href = isIOS ? IOS_APP_URL : ANDROID_APP_URL }, 1000)
        const domain = _get(window, "location.hostname")
        const redirectUrl = `mvi://${domain}/registration${token && "?token=" + token + "&source=" + source}`
        console.log(redirectUrl)
        window.location.href = redirectUrl
      },
      heading: "Redirect To App",
      title: "Continue to the mobile app?"
    })
    return
  }
  callback && callback()
}

export const startIntervalRequest = (
  checkIfFinished = () => false,
  onFinish = null,
  requestIntervalTime = 2 * 1000,
  intervalCleansingTime = 60 * 1000
) => {
  const interval = setInterval(() => {
    const isFinished = checkIfFinished()
    if (isFinished) {
      onFinish ? onFinish() : clearInterval(interval)
    }
  }, requestIntervalTime)
  const timeout = setTimeout(() => clearInterval(interval), intervalCleansingTime)

  return () => {
    clearInterval(interval)
    clearTimeout(timeout)
  }
}

export const updateMetaInfo = async ({role, navigation, dispatch}={}) => {
  const selectedDealer = _get(navigation, 'selectedDealer')
  const selectedManager = _get(navigation, 'selectedManager')

  if (isAdmin(role)) {
    if (selectedManager) await dispatch(getManagementMetaInfo(selectedManager))
    if (selectedDealer) await dispatch(getDealerMetaInfo(selectedDealer))
    await dispatch(getAdminMetaInfo())
  }

  if (isDealer(role)) {
    if (selectedManager) await dispatch(getManagementMetaInfo(selectedManager))
    await dispatch(getDealerMetaInfo())
  }

  if (isManager(role)) {
    await dispatch(getManagementMetaInfo())
  }

  return null
}

const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
export const sortMixedString = (a, b, order='asc') => {
  const aPart = a.match(/\d+|\D+/g)
  const bPart = b.match(/\d+|\D+/g)

  let i = 0
  const len = Math.min(aPart.length, bPart.length)

  while (i < len && aPart[i] === bPart[i]) { i++ }
  if (i === len) {
    return aPart.length - bPart.length
  }
  if (_isNumber(aPart[i]) && _isNumber(bPart[i])) {
    return aPart[i] - bPart[i]
  }
  if (order === 'asc')
    return collator.compare(aPart[i], bPart[i])
  else
    return collator.compare(bPart[i], aPart[i])
}

export const compareFuncByBuildingName = (a, b) => {
  if (a.building_name.toLowerCase() > b.building_name.toLowerCase()) {
    return 1;
  }
  if (a.building_name.toLowerCase() < b.building_name.toLowerCase()) {
    return -1;
  }
  return 0;
}
